import {
    FETCH_CUSTOMERS,
    FETCH_ORTHODONTIC_CUSTOMERS,
    FETCH_CUSTOMER_DETAIL,
    DELETE_CUSTOMERS,
    FETCH_ACTIVE_CUSTOMERS,
    FETCH_CUSTOMER_STATISTICS,
} from '../actions/types';

/**
 * helpers
 */
const getPagination = (p = {}, fallbackPerPage = 30) => ({
    currentPage: parseInt(p.current_page, 10) || 1,
    total: parseInt(p.total, 10) || 0,
    perPage: parseInt(p.per_page, 10) || fallbackPerPage,
});

const dedupeById = (arr = []) => {
    const seen = new Set();
    return arr.filter((item) => {
        if (!item || seen.has(item.id)) return false;
        seen.add(item.id);
        return true;
    });
};

/**
 * initial state
 */
const INIT_STATE = {
    list: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30,
        },
    },
    activeList: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 20,
        },
    },
    list_othodontic: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30,
        },
    },
    detail: null,
    createResult: null,
    updateResult: null,
    deleteResult: null,
    statistical: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        /**
         * Danh sách KH (load mới)
         */
        case FETCH_CUSTOMERS: {
            const payload = action.payload || {};
            return {
                ...state,
                list: {
                    items: payload.data || [],
                    pagination: getPagination(payload, 30),
                },
            };
        }

        /**
         * Danh sách KH chỉnh nha (load mới)
         */
        case FETCH_ORTHODONTIC_CUSTOMERS: {
            const payload = action.payload || {};
            return {
                ...state,
                list_othodontic: {
                    items: payload.data || [],
                    pagination: getPagination(payload, 30),
                },
            };
        }

        /**
         * Danh sách KH active (có thể dùng cho infinite scroll)
         * => nếu page 1: ghi đè; page >1: nối + dedupe
         */
        case FETCH_ACTIVE_CUSTOMERS: {
            const payload = action.payload || {};
            const isFirstPage = parseInt(payload.current_page, 10) === 1;

            const merged = isFirstPage
                ? (payload.data || [])
                : [...(state.activeList.items || []), ...(payload.data || [])];

            return {
                ...state,
                activeList: {
                    items: dedupeById(merged),
                    pagination: getPagination(payload, 20),
                },
            };
        }

        /**
         * Lấy chi tiết KH
         */
        case FETCH_CUSTOMER_DETAIL: {
            return {
                ...state,
                detail: action.payload || null,
            };
        }

        /**
         * Xoá KH
         */
        case DELETE_CUSTOMERS: {
            return {
                ...state,
                deleteResult: action.payload || null,
                // (tuỳ chọn) loại bỏ khỏi list/activeList nếu muốn đồng bộ UI ngay:
                // list: {
                //   ...state.list,
                //   items: (state.list.items || []).filter(i => i.id !== action.payload?.id)
                // },
                // activeList: {
                //   ...state.activeList,
                //   items: (state.activeList.items || []).filter(i => i.id !== action.payload?.id)
                // }
            };
        }

        /**
         * Thống kê (có field riêng trong INIT_STATE)
         */
        case FETCH_CUSTOMER_STATISTICS: {
            return {
                ...state,
                statistical: action.payload || null,
            };
        }

        default:
            return state;
    }
};
